import type {
  IStudioBreakdownBlock,
  IStudioBreakdownExcelConfig,
} from './types';

/** Normalize single-studio fields or explicit studioBlocks into one list. */
export const resolveStudioBreakdownBlocks = <TMonthRow>(
  config: IStudioBreakdownExcelConfig<TMonthRow>,
): IStudioBreakdownBlock<TMonthRow>[] => {
  if (config.studioBlocks?.length) {
    return config.studioBlocks;
  }
  return [{
    studioName: config.studioName ?? '',
    rawData: config.rawData ?? [],
    fixedRows: config.fixedRows ?? [],
  }];
};
